import '../pages.css';
import { Link } from 'react-router-dom';

const CompleteDenture = () => {
    return (
        <div className="page product-detail">
            <section className="product-detail-hero">
                <div className="product-detail-hero-content">
                    <Link to="/products/removable" className="back-link">← Back to Removable Prosthetics</Link>
                    <h1>Complete Denture</h1>
                    <p className="product-tagline">Premium quality for excellent function and stability</p>
                </div>
            </section>

            <section className="product-detail-content">
                <div className="content-container">
                    <div className="product-section">
                        <h2>Description</h2>
                        <p>
                            <strong>AbELab</strong> complete dentures are available in both premium and economy options, ensuring high-quality
                            solutions for every patient.
                        </p>
                        <p>
                            The premium complete denture features SR Phonares® denture teeth, known for their lifelike appearance and natural
                            translucency. All complete dentures are fabricated using the Ivoclar Ivocap Injection System, which enhances accuracy,
                            fit, and long-term comfort. Regardless of the selected option, AbELab complete dentures are designed to deliver
                            excellent function, stability, and patient satisfaction.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CompleteDenture;
